import { PromptRunStatus, PromptStatusMap, PromptType } from "@/schema/prompt"

type PromptStatusCarrier = {
  prompt_statuses?: PromptStatusMap
}

export function promptStatus(record: PromptStatusCarrier | undefined, promptType: PromptType): PromptRunStatus {
  return record?.prompt_statuses?.[promptType]?.status ?? "not_started"
}

export function isPromptInProgress(record: PromptStatusCarrier | undefined, promptType: PromptType): boolean {
  const status = promptStatus(record, promptType)
  return status === "active" || status === "retrying"
}

export function isPromptFinished(record: PromptStatusCarrier | undefined, promptType: PromptType): boolean {
  return promptStatus(record, promptType) === "finished"
}

export const meetingPromptStatus = promptStatus
export const isMeetingPromptInProgress = isPromptInProgress
export const isMeetingPromptFinished = isPromptFinished
